export default {
    setList(state, data) {
        state.list = data.data
        state.total = data.meta.total
    }
}
